import React, { useState, useEffect } from "react";
import {
  wlCandidateActivation,
  getWhiteLabelSettings,
} from "../redux/thunks/Auth";
import { useLocation } from "react-router-dom";
import { setClientData } from "../utils/utilities";
import AlertBox from "../components/common/AlertBox";
import { useDispatch, useSelector } from "react-redux";
import { tokenCookieName, RequestStatus } from "../utils/Constants";
import ProcessingIndicator from "../components/common/ProcessingIndicator";

export default function WhiteLabelCandidate() {
  const dispatch = useDispatch();
  const search = useLocation().search;
  const [alert, setAlert] = useState(null);
  const auth = useSelector((state) => state.authReducer);
  const refresh_token = new URLSearchParams(search).get("refresh_token");
  const access_token = new URLSearchParams(search).get("access_token");
  const client_id = new URLSearchParams(search).get("client_id");
  const wl_assess_id = new URLSearchParams(search).get("wl_assess_id");

  useEffect(() => {
    if (wl_assess_id) {
      localStorage.setItem("wl_assess_id", wl_assess_id);
    }
  }, [wl_assess_id]);

  useEffect(() => {
    if (client_id) {
      localStorage.setItem("wl_client_id", client_id);
    }
  }, [client_id]);

  useEffect(() => {
    if (access_token) {
      localStorage.setItem("wl_access_token", access_token);
    }
  }, [access_token]);

  useEffect(() => {
    if (refresh_token) {
      localStorage.setItem("wl_refresh_token", refresh_token);
    }
  }, [refresh_token]);

  const handleWhiteLabelSettings = async ({
    client_id,
    access_token,
    assess_id,
  }) => {
    localStorage.removeItem("wl_settings_data");
    const dispatched = await dispatch(
      getWhiteLabelSettings({
        client_id: client_id,
        access_token: access_token,
        assess_id: assess_id,
      })
    );

    if (dispatched.meta.requestStatus === RequestStatus.REJECTED) {
      setAlert(
        <AlertBox
          varrient={"dismiss"}
          varrientColor="danger"
          varrientTitle="Error"
          varrientDescription={`Expired: access_token`}
        />
      );
      return;
    }
  };

  useEffect(() => {
    setClientData(
      tokenCookieName,
      localStorage.getItem("wl_refresh_token")
        ? localStorage.getItem("wl_refresh_token")
        : refresh_token,
      7
    );
    if (access_token && client_id && wl_assess_id) {
      handleWhiteLabelSettings({
        client_id: client_id,
        access_token: access_token,
        assess_id: wl_assess_id,
      });
    } else if (
      localStorage.getItem("wl_assess_id") &&
      localStorage.getItem("wl_client_id") &&
      localStorage.getItem("wl_access_token")
    ) {
      handleWhiteLabelSettings({
        client_id: localStorage.getItem("wl_client_id"),
        access_token: localStorage.getItem("wl_access_token"),
        assess_id: localStorage.getItem("wl_assess_id"),
      });
    } else {
      setAlert(
        <AlertBox
          varrient={"dismiss"}
          varrientColor="danger"
          varrientTitle="Error"
          varrientDescription={`Missing: ${
            !access_token
              ? "access_token"
              : !client_id
              ? "client_id"
              : !wl_assess_id && "assess_id"
          }`}
        />
      );
      return;
    }
  }, [
    access_token,
    client_id,
    wl_assess_id,
    localStorage.getItem("wl_assess_id"),
    localStorage.getItem("wl_client_id"),
    localStorage.getItem("wl_access_token"),
  ]);

  useEffect(() => {
    if (auth.wl_settings_data) {
      localStorage.setItem(
        "wl_settings_data",
        JSON.stringify(auth.wl_settings_data)
      );
    }
  }, [auth.wl_settings_data]);

  return (
    <>
      {alert}
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ProcessingIndicator />
      </div>
    </>
  );
}
